import { useContext } from 'react'
import {
  type Config,
  ConfigContext,
} from '#src/contexts/config/ConfigContext.tsx'

export const useConfig = (): Config => {
  const context = useContext(ConfigContext)
  if (context === null) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }
  return context
}
